import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ContentContext = createContext(null);

// Prefix relative /api/media/... URLs with backend URL for absolute src
export function resolveMediaUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data);
    } catch {
      setContent({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content: content || {}, refresh, ready: content !== null }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used within ContentProvider");
  return ctx;
}

export function useImage(slot) {
  const { content } = useContent();
  return resolveMediaUrl(content?.images?.[slot]);
}
